/* sb-dc-genfetch.js — let anything that fetches a template URL handle the
   generated ones.

   Built-in templates live in dc_templates as "dcgen:<base64 spec>" rather
   than as files in storage. The Design Templates page and the ?tpl deep-link
   bridge both know about that, but the design center's OWN template panel
   (inside the 314KB augment bundle) just calls fetch(file_url) — which fails
   on a dcgen: URL, so it dropped all 55 and showed
   "업로드 템플릿 55장을 불러오지 못해 목록에서 뻐습니다".

   Rather than editing that bundle (which would mean re-uploading 314KB by
   hand), this teaches fetch itself to answer dcgen: URLs with the drawn SVG.
   Everything downstream then behaves as if the file really existed.

   Must load as a classic script BEFORE the augment bundle, and after
   sb-dc-tplgen.js which does the drawing. */
(function () {
  'use strict';

  var orig = window.fetch;
  if (typeof orig !== 'function' || orig.__dcGenWrapped) return;

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  var wrapped = function (input, init) {
    var url = urlOf(input);
    if (url.indexOf('dcgen:') === 0) {
      var svg = null;
      try { svg = window.__dcTplGen && window.__dcTplGen(url); } catch (e) {}
      if (svg) {
        return Promise.resolve(new Response(svg, {
          status: 200,
          headers: { 'Content-Type': 'image/svg+xml' }
        }));
      }
      return Promise.resolve(new Response('', { status: 404, statusText: 'template spec unreadable' }));
    }
    return orig.apply(this, arguments);
  };
  wrapped.__dcGenWrapped = true;
  window.fetch = wrapped;
})();
